export const allCountryPortfolio = {
    title: 'Technology portfolio analysis',
    description: `Displays all technology clusters of patent applications held by each country specified in the country comparison. This provides a broader overview. The cluster layout represents overall theme trends, similar to Cluster & Value Chain, while the bubble size reflects country-specific values (such as scores).`,
    displayColumn1: 'Display in one column',
    displayColumn2: 'Display in two columns',
    country: 'Country',
    xSelect1: 'Score (Technology Advancement)',
    ySelect1: 'Market Expectation',
    bubbleSelect1: 'Score (Technological Competitiveness)',
    bubbleSelect2: 'Number of Patent Applications',
    bubbleSelect3: 'Number of Forward Citations (Average)',
    copy: 'Copy',
    yAxisUnit: 'bn yen',
    labelArrayOverFlowMsg: 'Up to five labels can be displayed.',

    // 設定画面
    xLabel: 'X Axis',
    yLabel: 'Y Axis',
    setting: 'Configuration',
    size: 'Bubble Size',
    zoomSlider: 'Zoom Slider',
    nonDisplay: 'Do not fix the labels',
    initButton: 'Revert to Default'
}
